export const GET_PRODUCTS_LOADING="GET_PRODUCTS_LOADING"
export const GET_PRODUCTS_SUCCCESS="GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_ERROR="GET_PRODUCTS_ERROR"
